import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Icon, Segment } from 'semantic-ui-react'
import { useForm, Controller } from 'react-hook-form'
import axios from 'axios'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import currency from 'currency.js'
import DateTimePicker from 'react-datetime-picker'
import moment from 'moment'

import { useUIDispatch, useUIState } from '../../context/store'

import ProductSearchInput from '../../components/ProductSearchInput'
import DropdownAddAdditions from '../../components/DropdownAddAdditions'

const itemObject = {item:"", qty:0, price:""};

const currencyMask = createNumberMask({
    prefix: 'GHS ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 7, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
})

const AddMemo = React.memo(function Add() {
    const { 
        control, 
        handleSubmit, 
        setValue, 
        getValues 
    } = useForm({
        defaultValues: {
            items: [itemObject]
        }
    });
    const { items: storedItems } = getValues(); // eslint-disable-line
    // console.trace(items)
    const [open, setOpen] = useState(false);
    const [locations, setLocations] = useState([]);
    const [socialsOptions, setSocialsOptions] = useState([]);
    const [itemListInputs, setItemListInputs] = useState([
        getValues().items
    ]);

    const dispatch = useUIDispatch();
    const { query } = useUIState();

    // const handleClose = () => setShow(false);
    const addItem = () => setItemListInputs([
        ...itemListInputs,
        itemObject
    ]);

    const removeItem = (itemIndex) => {
        // let storeItems = getValues().items;
        let items = itemListInputs;
        // console.log('before: ',items);
        items.splice(itemIndex, 1);
        console.log(items);
        // storeItems.splice(itemIndex, 1);
        setItemListInputs([items]);
        // setValue('items', [storeItems]);
        console.log(storedItems);
    };

    const onSubmit = data => {
        // console.log(data);
        const { wp_rest } = window.theme_vars;
        const endpoint = `${wp_rest}social/v1/order`;
        data.items = data.items.map((item) => ({
            ...item,
            price: currency(item.price, {symbol: ''}).format()
        }));
        // console.log(endpoint);
        // console.log(data);
        console.log(dispatch);

        axios.post(endpoint, {...data, per_page: query.per_page}).then(res => {
            console.log('from api: ', res.data.order);
            dispatch({type:'STORE_ORDER', payload:res.data.order});
            dispatch({type:'UPDATE_TOTAL_PAGE', payload:res.data.total_pages});
            setOpen(false);
        })
    };

    const fetchThings = () => {
        const { wp_rest } = window.theme_vars;
        const urls = [
            axios.get(`${wp_rest}social/v1/locations`),
            axios.get(`${wp_rest}social/v1/socials`),
            axios.get(`${wp_rest}social/v1/statuses`),
        ];
        axios.all(urls).then(axios.spread((...responses) => {
            const loc = responses[0].data;
            const locationsObj = Object.keys(loc).map((x, i) => ({key:loc[x], text:loc[x], value:x}));
            setLocations(locationsObj);

            const socials = responses[1].data;
            const socialsObj = Object.keys(socials).map((x, i) => ({key:socials[x], text:socials[x], value:x}));
            setSocialsOptions(socialsObj);
        })).catch(errors => {
            // react on errors.
        });
    }
    // console.log('Locations: ', locations);

    useEffect(() => {
        // const { wp_rest } = window.theme_vars;
        // const urls = [
        //     axios.get(`${wp_rest}social/v1/locations`),
        //     axios.get(`${wp_rest}social/v1/socials`),
        //     axios.get(`${wp_rest}social/v1/statuses`),
        // ];
        // axios.all(urls).then(axios.spread((...responses) => {
        //     const loc = responses[0].data;
        //     const locationsObj = Object.keys(loc).map((x, i) => ({key:loc[x], text:loc[x], value:x}));
        //     setLocations(locationsObj);

        //     const socials = responses[1].data;
        //     const socialsObj = Object.keys(socials).map((x, i) => ({key:socials[x], text:socials[x], value:x}));
        //     setSocialsOptions(socialsObj);
        // })).catch(errors => {
        //     // react on errors.
        // });
    }, []);

    useEffect(() => {
        console.log('value has changed');
        console.log(storedItems);
    }, [storedItems])


    return (
        <>
        <Button basic compact primary size="tiny" style={{marginLeft:10}} onClick={() => setOpen(true)}>
            {/* <Icon name='plus' style={{marginRight:10}} /> */}
            Add New
        </Button>

        <Modal
            dimmer="blurring"
            open={open}
            onClose={() => setOpen(false)}
            onMount={fetchThings}>

            <Modal.Content>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group widths={2}>
                        <Form.Field width={5}>
                            <Controller
                                name="social"
                                defaultValue=""
                                control={control}
                                render={({onChange, value}) => <Form.Select fluid
                                    placeholder="Select..."
                                    label="Platform"
                                    value={value}
                                    options={socialsOptions}
                                    onChange={(e, data)=> onChange(data.value)}
                                />}
                            />
                        </Form.Field>

                        <Form.Field>
                            <label>Date</label>
                            <Controller
                                name="dateHolder"
                                defaultValue={new Date()}
                                control={control}
                                render={({value}) => {
                                    return <DateTimePicker
                                    input={false}
                                    onChange={date => {
                                        setValue('dateHolder', date);
                                        setValue('date', moment(date).format('LLL'));
                                    }}
                                    value={value}
                                    format={"yyyyMd h:m a"}
                                    showLeadingZeros={false}
                                    yearPlaceholder="YYYY"
                                    monthPlaceholder="MM"
                                    dayPlaceholder="DD"
                                    hourPlaceholder="hh"
                                    minutePlaceholder="mm"
                                />
                                }}
                            />
                            <Controller
                                name="date" 
                                defaultValue={moment(new Date()).format('LLL')} 
                                control={control} 
                                render={()=><input type="hidden" />} 
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group widths="3">
                        <Controller
                            name="customerName"
                            defaultValue=""
                            control={control}
                            render={({onChange, value}) => <Form.Input fluid
                                width={6}
                                label="Customer Name"
                                placeholder="Joe Maanu"
                                value={value}
                                onChange={onChange}
                            />}
                        />

                        <Controller
                            name="customerNumber"
                            defaultValue=""
                            control={control}
                            render={({value}) => <Form.Input fluid
                                width={4}
                                label="Phone Number"
                                children={
                                    <MaskedInput
                                      mask={[/[0]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                      placeholder="0260000000"
                                      guide={false}
                                      value={value}
                                      onChange={e=>setValue('customerNumber', e.target.value)}
                                    />
                                }
                            />}
                        />

                        <Form.Field width={6}>
                            <label>Location</label>
                            <Controller
                                name="location"
                                defaultValue=""
                                control={control}
                                render={({onChange, value}) => {
                                    // console.log('inside locations',locations);
                                return <DropdownAddAdditions
                                    placeholder='Choose Location'
                                    value={value}
                                    options={locations}
                                    onChange={onChange}
                                />}}
                            />
                        </Form.Field>
                    </Form.Group>


                    <Segment.Group>
                        <Segment secondary>
                            <Form.Group widths={3}>
                                <Form.Field width={12}><label>Item</label></Form.Field>
                                <Form.Field width={3}><label>Qty</label></Form.Field>
                                <Form.Field width={4}><label>Price</label></Form.Field>
                                <Form.Field width={1}></Form.Field>
                            </Form.Group>

                            {itemListInputs.map((x, i) => <Form.Group key={i} widths={3}>
                                <Form.Field width={12}>
                                    <Controller
                                        name={`items[${i}][item]`}
                                        control={control}
                                        defaultValue=""
                                        render={({onChange, value}) => <ProductSearchInput
                                            value={value}
                                            onChange={onChange}
                                            setID={(id) => setValue(`items[${i}][id]`, id)}
                                        />}
                                    />
                                    <Controller
                                        name={`items[${i}][id]`}
                                        defaultValue=""
                                        control={control}
                                        render={() => <input type="hidden" />}
                                    />
                                </Form.Field>

                                <Form.Field width={3}>
                                    <Controller
                                        name={`items[${i}][qty]`}
                                        control={control}
                                        defaultValue=""
                                        render={({value, onChange}) => <Form.Input fluid
                                            placeholder="0"
                                            type="number"
                                            onChange={onChange}
                                            value={value}
                                        />}
                                    />
                                </Form.Field>

                                <Form.Field width={4}>
                                    <Controller
                                        name={`items[${i}][price]`}
                                        control={control}
                                        defaultValue=""
                                        render={({value}) => <Form.Input fluid
                                            placeholder="0.00"
                                            type="number"
                                            children={
                                                <MaskedInput 
                                                    mask={currencyMask}
                                                    value={value}
                                                    onChange={e=>setValue(`items[${i}][price]`, e.target.value)}
                                                />
                                            }
                                        />}
                                    />
                                </Form.Field>

                                <Form.Field width={1}>
                                    <span className={`ui button ${itemListInputs.length === 1 ? 'disabled' : 'red'}`} onClick={()=>removeItem(i)} style={{marginRight:0,paddingRight:10,paddingLeft:10}}>
                                        <Icon name='delete' style={{marginRight:0,marginLeft:0}} />
                                    </span>
                                </Form.Field>
                            </Form.Group>)}
                        </Segment>

                        <Segment clearing>
                            <div className="ui right floated button blue" onClick={addItem}>Add Item</div>
                        </Segment>
                    </Segment.Group>
                </Form>
            </Modal.Content>

            <Modal.Actions>
                <Button color='black' onClick={() => setOpen(false)}>Cancel</Button>
                <Button
                    content="Save record"
                    labelPosition='right'
                    icon='checkmark'
                    onClick={handleSubmit(onSubmit)}
                    positive
                />
            </Modal.Actions>
        </Modal>
        </>
    )
});

export default AddMemo
